import type { Nullable } from './global.interface'
import type { ResultsLocation } from './location.interface'

export enum ScreenWidth {
  desktop = 1024,
  largeDesktop = 1500,
}

export type ToastType = 'success' | 'warning' | 'error' | ''

export interface Toast {
  displayed: boolean
  content: Nullable<string>
  type: ToastType
}

export interface ButtonInputOption<T = string> {
  value: T
  label: string
}

// Select Input
export enum LocationType {
  GOLF = 'golf',
  CITY = 'city',
  DEPARTMENT = 'department',
  REGION = 'region',
  PROXIMITY = 'proximity',
  COUNTRY = 'country',
}
export interface SelectOption {
  value: string
  fancyLabel: string
  label: string
}
export interface SelectGroup {
  label: string
  type?: string
  options: SelectOption[]
}
export type SelectOptions = SelectOption[] | SelectGroup[]

export type LocationItem = ResultsLocation & {
  fancyLabel: string
}
export interface LocationGroup {
  label: string
  type?: string
  options: LocationItem[]
}
